/**
 * beadPatterns — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const beadPatternsPack: ToilePack = {
    slug: 'bead-patterns',
    category: 'beads',
    name: 'Bead patterns',
    tagline: tagline('patterns', 'designs', 'treatments'),
    chips: chips('designs', 'treatments'),
    ratio: SQUARE,
    readings: [
        {key: 'cactus', label: 'Cactus', subject: 'a potted cactus with two arms and a small pink flower'},
        {key: 'heart', label: 'Heart', subject: 'a plump heart'},
        {key: 'fox', label: 'Little fox', subject: 'a fox sitting with its tail curled around its paws'},
    ],
    styles: [
        {key: 'pegboard', label: 'Pegboard grid', style: 'pattern chart, one colored circle per bead', palette: 'flat circles on a white grid', framing: 'exact grid, empty cells left white'},
        {key: 'fused', label: 'Fused beads', style: 'finished ironed piece, flattened bead rims', palette: 'glossy melted plastic', framing: 'flat on a white surface, from above'},
        {key: 'pastel', label: 'Pastel palette', style: 'loose beads standing on a clear pegboard', palette: 'mint, blush, lilac and cream', framing: 'flat, from directly above'},
    ],
    directions: ['a mushroom instead', 'in bright rainbow colors', 'on a larger grid'],
}
